import { createContext, useReducer, useRef } from 'react';
import { TimerAction } from '../action/timer.action';
import { TimerStage } from '../enum/timer-stage.enum';
import { TimerReducer } from '../reducer/timer.reducer';
import { TimerState } from '../state/timer.state';
import { getClampedElapsedSeconds } from '../util/timer.util';

const initialState = {
  startTime: 0,
  endTime: 0,
  stage: TimerStage.NotInit,
} as TimerState;

export const TimerContext = createContext<any>(initialState);

export const TimerStateProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(TimerReducer, initialState);
  const stateRef = useRef(state);
  stateRef.current = state;

  const initTimer = (endTime?: number) => {
    dispatch({
      type: TimerAction.INIT_TIMER,
      payload: {
        stage: TimerStage.NotInit,
        startTime: 0,
        endTime: endTime,
      },
    });
  };

  const startTimer = () => {
    const current = stateRef.current;
    let _endTime = new Date().getTime();
    if (current.endTime && current.endTime > 0) {
      _endTime = current.endTime;
    }
    dispatch({
      type: TimerAction.START_TIMER,
      payload: {
        stage: TimerStage.Started,
        startTime: _endTime,
        endTime: 0,
      },
    });
  };

  const stopTimer = () => {
    dispatch({
      type: TimerAction.STOP_TIMER,
      payload: {
        stage: TimerStage.Stopped,
        startTime: stateRef.current.startTime,
        endTime: new Date().getTime(),
      },
    });
  };

  const reSetTimer = (duration?: number, alreadyTaken?: number): number => {
    const currentTime = new Date().getTime();
    const timeTaken = getClampedElapsedSeconds(
      stateRef.current.startTime,
      alreadyTaken,
      duration,
    );

    dispatch({
      type: TimerAction.RESET_TIMER,
      payload: {
        startTime: currentTime,
        endTime: 0,
      },
    });

    return timeTaken;
  };

  const value = {
    stage: state.stage,
    startTime: state.startTime,
    initTimer,
    startTimer,
    stopTimer,
    reSetTimer,
  };

  return (
    <TimerContext.Provider value={value}>{children}</TimerContext.Provider>
  );
};
